import { createI18n } from "vue-i18n";
import kk from "./kk";
import ru from "./ru";
import en from "./en";

const messages = {
  kk,
  ru,
  en,
};

// Определяем язык по умолчанию
const defaultLocale = "kk";

// Получаем сохраненный язык из localStorage или используем язык браузера
const getDefaultLocale = () => {
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale && messages[savedLocale]) {
    return savedLocale;
  }

  // Определяем язык браузера
  const browserLocale = navigator.language.split("-")[0];
  if (messages[browserLocale]) {
    return browserLocale;
  }

  return defaultLocale;
};

const i18n = createI18n({
  legacy: false, // Используем Composition API
  locale: getDefaultLocale(),
  fallbackLocale: defaultLocale,
  messages,
  globalInjection: true, // Автоматически внедряем $t в компоненты
});

export default i18n;

// Функция для изменения языка
export const setLocale = (locale) => {
  if (messages[locale]) {
    i18n.global.locale.value = locale;
    localStorage.setItem("locale", locale);
    document.documentElement.lang = locale;
  }
};

// Функция для получения текущего языка
export const getCurrentLocale = () => {
  return i18n.global.locale.value;
};

// Функция для получения доступных языков
export const getAvailableLocales = () => {
  return Object.keys(messages);
};
